var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#default_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 1,
    fill: "url(#default_svg__b)",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59.5,
    height: 59.5,
    x: 1.25,
    y: 0.25,
    stroke: "#E6E1E5",
    strokeWidth: 0.5,
    rx: 9.75
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.892 12.867v3.95l5.047 5.73h-5.047V25H39.1l1.318-2.453zM30.067 22.547H25.02l5.046-5.73v-3.95l-.827.94-7.7 8.74L22.86 25h7.207z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "default_svg__b",
    x1: 4.281,
    x2: 56.313,
    y1: 3.281,
    y2: 57.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929395"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "default_svg__a",
    width: 62,
    height: 62,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export { SvgDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjIiIGhlaWdodD0iNjIiIHZpZXdCb3g9IjAgMCA2MiA2MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF8wXzEpIj4KPHJlY3QgeD0iMSIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiByeD0iMTAiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8wXzEpIi8+CjxyZWN0IHg9IjEuMjUiIHk9IjAuMjUiIHdpZHRoPSI1OS41IiBoZWlnaHQ9IjU5LjUiIHJ4PSI5Ljc1IiBzdHJva2U9IiNFNkUxRTUiIHN0cm9rZS13aWR0aD0iMC41Ii8+CjwvZz4KPHBhdGggZD0iTTMxLjg5MTYgMTIuODY3MlYxNi44MTcyTDM2LjkzOTQgMjIuNTQ3SDMxLjg5MTZWMjQuOTk5NkgzOS4wOTk3TDQwLjQxODQgMjIuNTQ3TDMxLjg5MTYgMTIuODY3MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMC4wNjY4IDIyLjU0NzJIMjUuMDIwN0wzMC4wNjY4IDE2LjgxNzRWMTIuODY3NEwyOS4yNCAxMy44MDYzTDIxLjU0IDIyLjU0NzJMMjIuODYwNCAyNC45OTk5SDMwLjA2NjhWMjIuNTQ3MloiIGZpbGw9IndoaXRlIi8+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RfMF8xIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iNjIiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iMSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIwLjUiLz4KPGZlQ29tcG9zaXRlIGluMj0iaGFyZEFscGhhIiBvcGVyYXRvcj0ib3V0Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjI1IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfMF8xIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9kcm9wU2hhZG93XzBfMSIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzBfMSIgeDE9IjQuMjgxMjUiIHkxPSIzLjI4MTI1IiB4Mj0iNTYuMzEyNSIgeTI9IjU3LjY1NjIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0IyQjhCRSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5MjkzOTUiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";